<template>
  <div id="cargoExpenseKanban">
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <kanban-board id="kanban-board" :towers="towers">
      <template v-slot:card="{ item }">
        <cargo-expense-kanban-card :item="item" @refreshData="fetchEventsList">
        </cargo-expense-kanban-card>
      </template>
      <template v-slot:tower-footer="{ amount }">
        <div v-if="amount === 1">{{ amount }} depesa</div>
        <div v-else>{{ amount }} depesas</div>
      </template>
    </kanban-board>
  </div>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import KanbanBoard from "@/components_rms/kanban_slot/KanbanBoardSlot.vue";
import CargoExpenseKanbanCard from "@/pagesRms/trackingShippingCompany/cargoExpenseKanban/CargoExpenseKanbanCard.vue";

export default {
  name: "CargoExpenseKanban",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    KanbanBoard,
    CargoExpenseKanbanCard,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      filter: {
        client: [],
        branchName: [],
        dateDeliveryForecast: [],
        dateAttendanceExpiration: [],
        origin: [],
        destination: [],
        vehiclePlate: [],
        driver: [],
        transportNumber: [],
      },
      filterApplied: {
        client: [],
        branchName: [],
        dateDeliveryForecast: [],
        dateAttendanceExpiration: [],
        origin: [],
        destination: [],
        vehiclePlate: [],
        driver: [],
        transportNumber: [],
      },
      isLoading: false,
      selectedTags: [],
      towers: [],
      towersFiltred: [],
    };
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  },
  created() {
    this.fetchEventsList();
    this.timer = setInterval(
      this.fetchEventsList,
      this.$store.getters.autoRefreshTime
    );
  },
  methods: {
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    fetchEventsList() {
      // console.log('fetchEventsList');
      this.loadData();
    },
    filterCards(tower, filters, propertyCompare, filterToAply) {
      if (filters[filterToAply]) {
        if (filters[filterToAply].length > 0) {
          tower.cards = tower.cards.filter((card) => {
            let tudocerto = false;
            filters[filterToAply].forEach((f) => {
              if (
                card[propertyCompare].toLowerCase().includes(f.toLowerCase())
              ) {
                tudocerto = true;
              }
            });
            return tudocerto;
          });
        }
      }
    },
    filterTowers() {
      if (!this.towers) return [];
      // console.log(this.towers);
      // console.log("ok")
      const filtredTowers = JSON.parse(JSON.stringify(this.towers));
      // console.log(filtredTowers);
      filtredTowers.forEach((t) => {
        this.filterCards(t, this.filterApplied, "clientName", "client");
        this.filterCards(t, this.filterApplied, "branchName", "branchName");
        this.filterCards(
          t,
          this.filterApplied,
          "dateAttendanceExpiration",
          "dateDeliveryForecast"
        );
        this.filterCards(
          t,
          this.filterApplied,
          "dateAttendanceExpiration",
          "dateAttendanceExpiration"
        );
        this.filterCards(t, this.filterApplied, "destination", "destination");
        this.filterCards(t, this.filterApplied, "origin", "origin");
        this.filterCards(t, this.filterApplied, "vehiclePlate", "vehiclePlate");
        this.filterCards(t, this.filterApplied, "driverName", "driver");
        this.filterCards(
          t,
          this.filterApplied,
          "transportNumber",
          "transportNumber"
        );
      });
      this.$forceUpdate();
      this.towersFiltred = filtredTowers;
    },
    async loadData() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.$api
        .get("/v1/cargoExpense/kanban/")
        .then((response) => {
          let model = response.data;
          // console.log(model)
          model.forEach((tower) => {
            tower.cards.forEach((card) => {
              card.url = `/trackingShippingCompany/cargoExpense/kanban/edit/${card.id}`;
              card.text = this.getText(card);
            });
          });
          this.towers = model;
          this.isLoading = false;
          //this.filterTowers();
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    getText(card) {
      let text = `Carga: ${card.cargoId}`;
      text += `\nSolicitante: ${card.creationUserDisplayname}`;
      text += `\nCliente: ${card.clientName}`;
      text += `\nTipo de despesa: ${card.cargoExpenseTypeDescription}`;
      text += `\nAnexos: ${card.attachmentsQuantity}`;
      text += `\nMotorista: ${card.driverName}`;
      text += `\nNúmero de transporte: ${card.transportNumber}`;
      if (card.customValues != null) {
        card.customValues.forEach((value) => {
          text += `\n${value.fieldName}: ${value.value}`;
        });
      }

      //   if (isOpened) {
      //     text += `\nData de expiração: ${this.dateToString(
      //       card.dateAttendanceExpiration
      //     )}`;
      //   }
      //   text += `\nOrigem: ${card.origin}`;
      //   text += `\nDestino: ${card.destination}`;

      //   if (!isOpened && card.lastStatusId != 12) {
      //     text += `\nPlaca: ${card.vehiclePlate}`;
      //     text += `\nMotorista: ${card.driverName}`;
      //   }
      //   // text += `\nLastStatus: ${card.lastStatusId}`;

      return text;
    },
    dateToString(value) {
      let date = new Date(value);
      return date.toLocaleDateString();
    },
    // modalCancel() {
    //   alert("cancelar");
    // },
    modalReset() {
      this.filter.client = Array.from(this.filterApplied.client);
      this.filter.branchName = Array.from(this.filterApplied.branchName);
      this.filter.dateDeliveryForecast = Array.from(
        this.filter.dateDeliveryForecast
      );
      this.filter.dateAttendanceExpiration = Array.from(
        this.filter.dateAttendanceExpiration
      );
      this.filter.origin = Array.from(this.filterApplied.origin);
      this.filter.destination = Array.from(this.filterApplied.destination);
      this.filter.vehiclePlate = Array.from(this.filterApplied.vehiclePlate);
      this.filter.driver = Array.from(this.filterApplied.driver);
    },
    modalOk() {
      // alert("ok");
      // this.filterApplied = this.filter;
      this.filterApplied.client = Array.from(this.filter.client);
      this.filterApplied.branchName = Array.from(this.filter.branchName);
      this.filterApplied.dateDeliveryForecast = Array.from(
        this.filter.dateDeliveryForecast
      );
      this.filterApplied.dateAttendanceExpiration = Array.from(
        this.filter.dateAttendanceExpiration
      );
      this.filterApplied.origin = Array.from(this.filter.origin);
      this.filterApplied.destination = Array.from(this.filter.destination);
      this.filterApplied.vehiclePlate = Array.from(this.filter.vehiclePlate);
      this.filterApplied.driver = Array.from(this.filter.driver);

      this.filterTowers(this.towers);
    },
  },
};
</script>

<style scoped>
#kanban-board {
  height: calc(100vh - 100px);
}

.btn-tag {
  font-size: 0.875rem;
}
.form-control-tag {
  border: none;
}
.right {
  text-align: right;
  width: 100%;
}
.kanban-modal {
  z-index: 1060;
}
.search-icon {
  background: #2c3b5d;
  width: 3rem;
  height: 100%;
  padding-top: 8px;
  text-align: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
</style>